import React from 'react';
import { StyledPurpleContainer } from '@/operator/components/modules/AuthPage/Styles';
import { MessageWithTipMui } from '@/operator/components/modules/AuthPage/setup/MessageWithTipMui';
import { IconContainer } from './Styles';

interface StatePageProps {
    headline: string;
    description: string | React.ReactElement | null;
    actionElement?: JSX.Element;
    imagePath: string | null;
    secondDescription?: string | null;
    background?: string;
    width?: string;
    height?: string;
    imgDimension?: string;
}

export const StatePage = ({
    headline,
    description,
    imagePath,
    actionElement,
    secondDescription,
    background,
    width,
    height,
    imgDimension,
}: StatePageProps): JSX.Element => {
    const url = imagePath;

    return (
        <StyledPurpleContainer $background={background}>
            <img
                alt="searching"
                src={url}
                height={imgDimension}
                width={imgDimension}
            />
            <div style={{ height: height || '40vh', width: width || '70vw' }}>
                <MessageWithTipMui
                    headlineVariant="h2"
                    headlineAlignment="center"
                    headline={headline}
                    descriptionAlignment="center"
                    description={description}
                    secondDescription={secondDescription}
                />
                <IconContainer>{actionElement}</IconContainer>
            </div>
        </StyledPurpleContainer>
    );
};

export default StatePage;
